var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoNoti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 357,
    viewBox: "0 0 300 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 207C2.5 125.538 68.538 59.5 150 59.5C231.462 59.5 297.5 125.538 297.5 207C297.5 288.462 231.462 354.5 150 354.5C68.538 354.5 2.5 288.462 2.5 207Z",
    stroke: "#999999",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.389 71.439C104.587 101.347 135.628 116.965 135.628 116.965C135.628 116.965 146.894 84.0925 134.696 54.1844C122.499 24.2764 91.4568 8.65845 91.4568 8.65845C91.4568 8.65845 80.1913 41.531 92.389 71.439Z",
    fill: "#3F3D56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.735 54.24C142.602 82.3736 135.567 116.403 135.567 116.403C135.567 116.403 102.805 104.819 86.938 76.6858C71.0705 48.5523 78.1059 14.5226 78.1059 14.5226C78.1059 14.5226 110.868 26.1064 126.735 54.24Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.524 54.3439C128.572 84.3509 140.106 117.13 140.106 117.13C140.106 117.13 171.019 101.258 182.971 71.2509C194.923 41.2439 183.388 8.46484 183.388 8.46484C183.388 8.46484 152.476 24.3368 140.524 54.3439Z",
    fill: "#3F3D56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.889 68.0429C167.811 99.3163 139.144 118.955 139.144 118.955C139.144 118.955 123.573 87.8902 131.65 56.6168C139.728 25.3433 168.395 5.70422 168.395 5.70422C168.395 5.70422 183.966 36.7694 175.889 68.0429Z",
    fill: "#999999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.225 305C206.272 305 250.085 261.186 250.085 207.14C250.085 153.093 206.272 109.279 152.225 109.279C98.178 109.279 54.3643 153.093 54.3643 207.14C54.3643 261.186 98.178 305 152.225 305Z",
    fill: "#999999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.844 247.138C174.618 247.138 197.133 224.623 197.133 196.849C197.133 169.075 174.618 146.559 146.844 146.559C119.069 146.559 96.5541 169.075 96.5541 196.849C96.5541 224.623 119.069 247.138 146.844 247.138Z",
    fill: "#F2F2F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.095 239.585C158.103 239.585 165.406 232.282 165.406 223.274C165.406 214.267 158.103 206.964 149.095 206.964C140.088 206.964 132.785 214.267 132.785 223.274C132.785 232.282 140.088 239.585 149.095 239.585Z",
    fill: "#3F3D56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNoti);
export default __webpack_public_path__ + "static/media/no_noti.ea6c7bd0ac8f76542d7871b6d3f261f4.svg";
export { ForwardRef as ReactComponent };